import { IDmNganh } from "../../../model/respone/category/IDmNganh";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDmNganhActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IDmNganh[],
  LOAD_ERRR: "",

  SHOW_EDIT_MODAL: {} as IDmNganh | undefined,
  CLOSE_EDIT_MODAL: undefined,

  SAVE_START: {} as IDmNganh,
  SAVE_SUCCESS: undefined,
  SAVE_ERRR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERRR: "",
};
export const eDmNganhActionIds = generateActionTypeIds(
  eDmNganhActionsObj,
  "NGANH"
);
export type IDmNganhActionTypes = IGenericActionType<
  typeof eDmNganhActionsObj,
  "NGANH"
>;
